import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components/macro";
import TopMenu from "@as_core/menus/TopMenu";
import { UserContext } from '@as_core/contexts/UserContext';
import { useApiInfo } from '@utils/apiInfo';
import { APP_CONFIG } from '@app_config/app';

interface propsT {
  title: string;
  appTitle?: string | React.ReactNode;
  centerBanner?: string | React.ReactNode;
  padding?: number;
  children: React.ReactNode;
  scroll?: boolean;
}

const debug = false;
const PageContainer = (props: propsT) => {
  const { title, centerBanner = '', padding = 0, scroll = true } = props;
  const { user } = useContext(UserContext);
  if (debug) console.log("PageContainer | title:", title, " user:", user);
  const [infoLoaded, setInfoLoaded] = useState<boolean>(false);
  const [appType, setAppType] = useState<string>('');
  const { getVersionLabel } = useApiInfo();
  const [version, setVersion] = useState('');

  useEffect(() => {
    if (user.isAuthenticated && !infoLoaded) {
      let app_type = '';
      if (!process.env.REACT_APP_HOST_TYPE.includes('prd')) {
        app_type = ' (' + process.env.REACT_APP_HOST_TYPE + ')';
      } else if (process.env.REACT_APP_HOST_TYPE.includes('prd-')) {
        const client = process.env.REACT_APP_HOST_TYPE.replace('prd-', '');
        app_type = ' (' + client + ')';
      }
      setAppType(app_type);
      getVersionLabel().then((version) => {
        if (debug) console.log("getVersionLabel:", version);
        setInfoLoaded(true);
        setVersion(version);
      });
    }
  }, [infoLoaded]);

  return (
    <Container>
      <TopMenu appTitle={props?.appTitle ? props.appTitle : APP_CONFIG.name} title={title} centerBanner={centerBanner} />
      <PageContent padding={padding}>
        {scroll ?
          <ScrollBox padding={padding}>
            {props.children}
          </ScrollBox>
          :
          <>
            {props.children}
          </>
        }
      </PageContent>
      <PageFooter inColor={(appType !== '')}>vers:{version}</PageFooter>
    </Container>
  );
};

export default PageContainer;

const Container = styled.div`
  position: fixed;
  height: 100vh;
  width: calc(100vw - 50px);
  top: 0;
  left: 50px;
`;

const PageContent = styled.div<{
  padding: number,
  children?: React.ReactNode
}>`
  position: relative;
  height: calc(100vh - 50px - 2*${(p)=>p.padding}'px');
  width: calc(100vw - 50px - 2*${(p)=>p.padding}'px');
  background-color: ${(p) => p.theme.palette.backgroundPrimary};
  padding: ${(p) => p.padding}px;
  flex: auto;
  & ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  & ::-webkit-scrollbar-track {
    background: transparent;
  }
  & ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.palette.accentPrimary};
    border-radius: 5px;
  }
  & ::-webkit-scrollbar-thumb:hover {
    background: ${(p) => p.theme.palette.accentSecondary};
  }
`;

const ScrollBox = styled.div<{
  padding: number,
  children?: React.ReactNode
}>`
  height: calc(100vh - 60px - 2*${(p)=>p.padding}px);
  background-color: transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 0;
`;

const PageFooter = styled.div<{
  inColor?: boolean,
  children?: React.ReactNode
}>`
  position: absolute;
  height: 12px;
  font-size: 8px;
  line-height: 10px;
  padding-left: 5px;
  bottom: 0;
  right: 20px;
  color: ${(p) => (p.inColor) ? 'yellow' : p.theme.palette.textQuaternary};
  background-color: ${(p) => p.theme.palette.backgroundPrimary};
  z-index: 0;
`;
PageFooter.defaultProps = {
  inColor: false
}
